import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import langEn from './lang.en.json';
import langKo from './lang.ko.json';
import {getDecStorage} from '../common/common';
import {eSessionKeys} from 'src/common/const';

const resource = {
  'en-US': {
    translation: langEn,
  },
  'ko-KR': {
    translation: langKo,
  },
};

i18n.use(initReactI18next).init({
  resources: resource,

  /* Set default language */
  // lng: isNull(getDecStorage(eSessionKeys.USER_SELECT_LANGUAGE)) ? getDecStorage(eSessionKeys.LANGUAGE) : getDecStorage(eSessionKeys.USER_SELECT_LANGUAGE),
  // lng: localStorage.getItem("language"),
  lng: getDecStorage(eSessionKeys.LANGUAGE),

  fallbackLng: {
    'en-US': ['en-US'],
    default: ['ko-KR'],
  },
  debug: false,
  defaultNS: 'translation',
  ns: 'translation',
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
